import Image, { ImageProps } from 'next/image';

const shimmer = (width: number, height: number) => `
<svg width="${width}" height="${height}" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <defs>
    <linearGradient id="g">
      <stop stop-color="#e2e8f0" offset="20%" />
      <stop stop-color="#cbd5e1" offset="50%" />
      <stop stop-color="#e2e8f0" offset="70%" />
    </linearGradient>
  </defs>
  <rect width="${width}" height="${height}" fill="#e2e8f0" />
  <rect id="r" width="${width}" height="${height}" fill="url(#g)" />
  <animate xlink:href="#r" attributeName="x" from="-${width}" to="${width}" dur="1s" repeatCount="indefinite"  />
</svg>`;

const toBase64 = (str: string) => (typeof window === 'undefined' ? Buffer.from(str).toString('base64') : window.btoa(str));

type Props = Omit<ImageProps, 'blurDataURL' | 'placeholder'>;

const WIDTH = 100;
const HEIGHT = 100;

/**
 * @deprecated Use `@pflegia/ui/shared/image-with-shimmer/ImageWithShimmer.component` instead.
 */
const ImageWithShimmer = ({ alt, ...props }: Props) => (
  <Image {...props} alt={alt} placeholder='blur' blurDataURL={`data:image/svg+xml;base64,${toBase64(shimmer(WIDTH, HEIGHT))}`} />
);

export default ImageWithShimmer;
